import { useContext, useEffect, useState } from "react";
import { ConstructionObjectDto } from "../../../../dtos/catalogs/ConstructionObject/ConstructionObjectDto";
import { FormProvider, useForm } from "react-hook-form";
import ConstructionObjectDetailSkeleton from "./ConstructionObjectDetailSkeleton";
import ConstructionObjectDetailMain from "./ConstructionObjectDetailMain";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";

interface IProps {
  model: ConstructionObjectDto | null;
  modelUpdatedEvent: (newModel: ConstructionObjectDto) => void;
}

interface ConstructionObjectModel {
  id: string;
  name: string;
  uniqueCode?: string;
  createdDate?: Date;
}

const ConstructionObjectDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ConstructionObjectModel>();
  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ConstructionObjectModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: ConstructionObjectDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };
  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  if (!model) {
    return (
      <>
        <ConstructionObjectDetailSkeleton />
      </>
    );
  }

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
      </NFTabs>
      <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

      <NFTabContainer index={0} currentIndex={tabIndex}>
        <ConstructionObjectDetailMain />
      </NFTabContainer>
    </FormProvider>
  );
};

export default ConstructionObjectDetail;
